import React, { useState, useEffect, useCallback } from 'react';
import Edit from '../../icons/edit.svg';
import './PreviewBar.scss';

const REFRESH_ENDPOINT = process.env.GATSBY_REFRESH_ENDPOINT;
const PreviewBar = () => {
  const [message, setMessage] = useState('');
  const [loadedEdit, setLoadedEdit] = useState(false);
  const [edit, setEdit] = useState(false);
  const toggleEdit = useCallback(() => setEdit((value) => !value), []);

  useEffect(() => {
    if (!loadedEdit) {
      const savedEdit = window.sessionStorage.getItem(
        'development-preview-edit'
      );
      setEdit(savedEdit === 'true');
      setLoadedEdit(true);
    }
  }, [loadedEdit]);

  const refresh = useCallback(async () => {
    setMessage('');
    const response = await fetch(REFRESH_ENDPOINT || '/__refresh', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    });

    if (response.status !== 200) {
      setMessage(`Refresh non disponbile ${response.status}`);
    }
  }, []);

  useEffect(() => {
    const event = new CustomEvent('development-preview-edit', {
      detail: {
        enabled: edit,
      },
    });
    document.dispatchEvent(event);
    window.sessionStorage.setItem('development-preview-edit', edit);
  }, [edit]);

  return (
    <div
      id='development-preview-bar'
      className='preview-bar'
      style={{
        '--bg': 'var(--red-10bd)',
        '--cl': 'var(--bianco)',
        '--bg-hover': 'var(--red-main-color)',
      }}
    >
      <button onClick={refresh} type='submit' className='btn btn--primary '>
        Refresh
      </button>
      <span>{message}</span>
      <button
        onClick={toggleEdit}
        className={`preview-bar__edit${
          edit ? ' preview-bar__edit--enabled' : ''
        }`}
      >
        <Edit />
      </button>
    </div>
  );
};

export default PreviewBar;
